import Vue from 'vue';
import ActAlertDialog from './ActAlertDialog.vue';
import preload from '../../../tools/preload'
let instance;


const defaultOptions = {
  value: true,
  overlay: true,
  lockOnScroll: true,
  closeOnClickOverlay: true,
  callback: action => {
    instance[action === 'confirm' ? 'resolve' : 'reject'](action);
  },
  title: "<p>提示1</p><p>提示2</p>",
  button: "确认"
};

let currentDefaultOptions = {
  ...defaultOptions
};

const initInstance = () => {
  const DialogConstructor = Vue.extend(ActAlertDialog);
  instance = new DialogConstructor({
    el: document.createElement('div')
  });

  instance.$on('input', value => {
    instance.value = value;
  });

  document.body.appendChild(instance.$el);
};

const Dialog = options => {
  return new Promise((resolve, reject) => {
    if (!instance) {
      initInstance();
    }

    Object.assign(instance, {
      resolve,
      reject,
      ...options
    });
  });
};

//
Dialog.show = options => {
  if(typeof options === 'object'){
    return Dialog({
      ...currentDefaultOptions,
      ...options
    });
  }else if(typeof options === 'string'){
   return  Dialog({
      ...currentDefaultOptions,
     title: `<div style="text-align: center;font-size:.36rem">${options}<div>`
    });
  }
}



// //简易显示文本
// Dialog.show_simple = (tip_text) => Dialog({
//   ...currentDefaultOptions,
//   title: null,
//   content: `<div style="text-align: center;font-size:.36rem">${tip_text}<div>`
// });


Dialog.close = () => {
  instance.value = false;
};

Dialog.setDefaultOptions = (options = {}) => {
  currentDefaultOptions = {
    ...currentDefaultOptions,
    ...options
  };
};

Dialog.resetDefaultOptions = () => {
  currentDefaultOptions = {
    ...defaultOptions
  };
};

Vue.prototype.$act_alert_dialog = Dialog;
window.$act_alert_dialog = Dialog;

export default Dialog;
export {
  ActAlertDialog as Dialog
};


preload([
  "//vipcdn.mgtv.com/upload/20180408/close.png",
  "//vipcdn.mgtv.com/upload/20180408/btn.png",
]);



// WEBPACK FOOTER //
// ./src/components/Popups/ActAlertDialog/index.js